import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';

import MenuItem from '@material-ui/core/MenuItem';
import Fade from 'react-reveal/Fade';

import './Guardian.css';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"#FFF" ,
            secondary: "#FFF"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});
const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
	},
    disabled: {},
    focused: {},
    error: {}
}

class DGRGuardian extends Component {


    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        //REQUIRE POPULATED USER FIELDS
        if (this.props.DGRStore.debugMode === false){
            const { first_name, last_name, zipcode, phone, gender  } = this.props.DGRStore.values;
            const { birthday } = this.props.DGRStore
            if (!first_name || !last_name || !zipcode || !phone || !gender || !birthday) {
                return this.props.history.push('create_pass');
            }
        }
        setDigitalData( 'guardian', this.props.DGRStore.club_number );
    }
   
    handleChange = (e) => {
        this.props.DGRStore.setValue(e.target.name,e.target.value);
    }

    handleSubmit = (e) => {
        const { membership_flow} = this.props.DGRStore.values;

        this.props.DGRStore.createPassWithGuardian().then( () => {

            if ( membership_flow ){
                const { club_product_id, club_number } = this.props.DGRStore 
                sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
            } else {
                this.props.history.push('first_visit');
            }
        });
    }

    render(){
        const { classes } = this.props;
        const {
            guardian_first_name ,
            guardian_last_name ,
            guardian_address ,
            guardian_zip ,
            guardian_city ,
            guardian_state ,
            guardian_phone 
        } = this.props.DGRStore.values;

        const statesArray = [
            "AL",
            "AK",
            "AS",
            "AZ",
            "AR",
            "CA",
            "CO",
            "CT",
            "DE",
            "DC",
            "FM",
            "FL",
            "GA",
            "GU",
            "HI",
            "ID",
            "IL",
            "IN",
            "IA",
            "KS",
            "KY",
            "LA",
            "ME",
            "MH",
            "MD",
            "MA",
            "MI",
            "MN",
            "MS",
            "MO",
            "MT",
            "NE",
            "NV",
            "NH",
            "NJ",
            "NM",
            "NY",
            "NC",
            "ND",
            "MP",
            "OH",
            "OK",
            "OR",
            "PW",
            "PA",
            "PR",
            "RI",
            "SC",
            "SD",
            "TN",
            "TX",
            "UT",
            "VT",
            "VI",
            "VA",
            "WA",
            "WV",
            "WI",
            "WY"
        ]
        const states = statesArray.map( (state, i ) => {
            return ( 
                <MenuItem
                    classes={{
                        root: classes.menuItem 
                      }}

                    key={state} 
                    value={state}>
                        {state}
                    </MenuItem>
            ); 
        })
        return(
            <div className='guardian'> 

			<Fade>
                <div className="dgrTitleText">
                    <h2>Please enter guardian information to continue</h2> 
                </div>
            <MuiThemeProvider theme={theme}>
            <ValidatorForm
                className="createGuardianItems"
                ref="form"
                instantValidate = {false}
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)}
            >
                <div className="row">
                    <TextValidator
                        label="First Name"
                        className="fname"
                        onChange={this.handleChange}
                        name="guardian_first_name"
                        value={guardian_first_name}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                    <TextValidator
                        label="Last Name"
                        className="lname"
                        onChange={this.handleChange}
                        name="guardian_last_name"
                        value={guardian_last_name}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                </div>
                <div className="row">
                    <TextValidator
                        label="Phone"
                        className="phone"
                        onChange={this.handleChange}
                        name="guardian_phone"
                        value={guardian_phone}
                        validators={['required']}
                        errorMessages={['this field is required' ]}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                    <TextValidator
                        label="Zip"
                        className="zipcode"
                        onChange={this.handleChange}
                        name="guardian_zip"
                        value={guardian_zip}
                        validators={['required']}
                        errorMessages={['this field is required' ]}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                    <SelectValidator
                        label="State"
                        name="guardian_state"
                        className="state"
                        value={guardian_state}
                        onChange={this.handleChange}
                        InputProps={{
                            name: 'guardian_state',
                            id: 'guardian_state',
                            classes: {
                                underline: classes.underline,
                            },
                        }}
                        validators={['required']}
                        errorMessages={['this field is required' ]}
                    >
                        {states}
                    </SelectValidator> 
                </div>
                <div className="row">
                    <TextValidator
                        label="Address"
                        className="address"
                        onChange={this.handleChange}
                        name="guardian_address"
                        value={guardian_address}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                    <TextValidator
                        label="City"
                        className="city"
                        onChange={this.handleChange}
                        name="guardian_city"
                        value={guardian_city}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        InputProps={{
                            classes: {
                                input: classes.resize,
                                underline: classes.underline
                            },
                        }}
                    />
                </div>
                <div className="submitButton">
                <button className="bigButton" type="submit">Next ></button>
                </div>
            </ValidatorForm>
            </MuiThemeProvider>
			</Fade>
            </div>
        )
    }
}


DGRGuardian = inject('DGRStore','DGRModalStore', 'DGRBackgroundStore')(observer(DGRGuardian ))     
//export default DGRGuardian  ;
export default withStyles(styles)(DGRGuardian);



// WEBPACK FOOTER //
// ./src/components/DGR/Guardian/Guardian.js